/**
 * Hand-off from Home's "Send to a Friend" / "Beat the Monkey" to Create (specs/home-page AC-10, AC-10b):
 * Home stashes the slate's slips here right before navigating, `CreatePageProvider` consumes them once
 * and clears the store. In-memory on purpose: the hand-off happens within one session, a new send
 * replaces an old one.
 */

import { create } from 'zustand';
import type { PickSlip } from '../../create/types/create.types';

/** Who the slate is for. Absent = the player picks a rival in Create; `monkey` = pre-selected, open at review. */
export type SlatePrefillOpponent = 'monkey';

export interface SlatePrefill {
  slips: PickSlip[];
  /** Earliest kickoff of the sent matches; Create opens on that day. */
  selectedDateIso: string | null;
  slateDate: string;
  opponent?: SlatePrefillOpponent;
}

interface PendingSlatePrefillState {
  prefill: SlatePrefill | null;
  setPrefill: (prefill: SlatePrefill) => void;
  clear: () => void;
}

export const usePendingSlatePrefillStore = create<PendingSlatePrefillState>((set) => ({
  prefill: null,
  setPrefill: (prefill) => set({ prefill }),
  clear: () => set({ prefill: null }),
}));
